ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
NotificationList = require 'views/notification/notification-list'
React = require 'react'
t = require('views/internal/recup-with-helpers')('member_notifications')
_ = require 'underscore'

class MemberNotificationsComponent extends React.Component
  displayName: 'MemberNotifications'

  constructor: (props) ->
    super
    @loadMore = @loadMore.bind(@)
    @updateNotifications = @updateNotifications.bind(@)
    @state =
      isMore: false
      notifications: []

  componentDidMount: ->
    @props.listenTo 'add:Notification remove:Notification change:Notification', @updateNotifications
    @updateNotifications()

  updateNotifications: ->
    notifications = Notification.sortedByDateDescending(ModelCache)
    @setState
      notifications: notifications
      isMore: true

  loadMore: ->
    ModelLoader.loadMoreNotificationData @props.member.get('username'), Notification.PAGE_SIZE
    .then (notifications) =>
      @setState
        isMore: notifications.length > Notification.PAGE_SIZE - 1
    .done()

  render: t.renderable ->
    t.div =>
      t.div '.window-module-title', ->
        t.span '.window-module-title-icon.icon-lg.icon-notification'
        t.h3 ->
          t.format 'notifications'

      if @state.notifications.length == 0
        t.div '.empty-list', ->
          t.format 'no-notifications'

      t.div '.js-list-notifications', =>
        t.createElement NotificationList, { notifications: @state.notifications, context: 'notifications-page' }

      t.a '.show-more.js-more-notifications', { onClick: @loadMore, class: t.classify({ "hide": !@state.isMore }) }, ->
        t.format 'load-more-notifications'

module.exports = ModelCacheListener(MemberNotificationsComponent)



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-notifications-component.coffee